import { APP_VERSION, BUILD_TIMESTAMP, VERSION_JSON_URL } from "../version";

export interface VersionInfo {
  /** semver */
  version: string;
  /** 빌드 식별자 ISO-8601 UTC, "2026-06-17T07:30:16Z" */
  build_timestamp: string;
}

/** 로컬 번들과 원격 version.json 을 비교해 업데이트 필요 여부를 판단 */
export function hasUpdate(local: VersionInfo, remote: VersionInfo | null): boolean {
  if (!remote || typeof remote.version !== "string") return false;
  /**
   * build_timestamp 는 빌드마다 유일하므로 둘 다 있으면 이걸로 비교(모든 배포 감지)
   * build_timestamp 가 없는경우 (dev 빌드 등, 빈 문자열)
   * version(semver) 비교로 폴백
   */
  if (local.build_timestamp && remote.build_timestamp) {
    return remote.build_timestamp !== local.build_timestamp;
  }
  return remote.version !== local.version;
}

/** version.json 을 캐시 없이 가져온다 */
export async function fetchRemoteVersion(): Promise<VersionInfo | null> {
  try {
    const res = await fetch(VERSION_JSON_URL, { cache: "no-store" });
    if (!res.ok) return null;
    const data = (await res.json()) as Partial<VersionInfo>;
    if (typeof data.version !== "string") return null;
    return {
      version: data.version,
      build_timestamp: typeof data.build_timestamp === "string" ? data.build_timestamp : "",
    };
  } catch {
    return null;
  }
}

/** 현재 번들 대비 새 버전이 배포되었는지 확인 */
export async function checkForUpdate(): Promise<boolean> {
  const remote = await fetchRemoteVersion();
  return hasUpdate({ version: APP_VERSION, build_timestamp: BUILD_TIMESTAMP }, remote);
}
